export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 5;
export const RESULTS_PER_PAGE = 10;
export const KEY = '084f5765-8bc3-40d0-a966-09e9f627c541';
export const CLOSE_WINDOW = 1.5;
